<template>
    <div style="position: relative;height: 100%;width:100%;display: inline-block;">
        <files-browser v-if="browserType == 'fusion'" :enableAssetMultiSelect="true" :workspaceList="getWorkspacesList" @close="closeModal" @handleFilesBrowse="handleFilesBrowse"></files-browser>
        <div class="height-set">
            <div style="height: 100%;display: inline-block;width: 100%;">
                <div class="w-100 h-100" style="display:inline-block">
                    <div style="display: inline-block;width: 100%;height: 64px;">
                        <nav aria-label="breadcrumb" style="float:inline-start;width:100%;">
                            <ol class="breadcrumb comm-settings-top-nav m-0" style="float:inline-start;">
                            <li>
                                <back-button  v-on:click.native="changeComponent('facedtection-profiles')" style="position: relative;bottom:0px;inset-inline-start:5px;"></back-button>
                            </li>
                            <li class="breadcrumb-item active-text-nav-bar" aria-current="page" style="font-size:18px;" :title="personalityData.display_name">{{personalityData.name}}</li>
                            </ol>

                            <div class="primary-btn-style justify-content-end d-inline-flex col-md-6" style="padding:11px;float:inline-end;">
                                <button class="learn-about-text-styles" @click="openLearnAboutPanel()" style="width:200px">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                                    <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
                                    </svg>
                                    {{$t('Learn about Train Profile')}}
                                </button>
                            </div>
                        </nav>
                    </div>
                    <nav class="navbar navbar-expand-lg p-0" style="height:45px">
                        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                            <div class="navbar-nav w-100 top-nav-bar" style="align-items: center;">
                                <div style="float: inline-start;width: 70%;display: inline-block;">    
                                    <a class="nav-item nav-link w-50" @click="switchProfileTabs('tag-faces')" :class='(activeTab == "tag-faces")?"active":"inactive"' style="width:20% !important;font-size:18px;">{{$t('Tag Faces')}}</a>
                                    <a class="nav-item nav-link w-50" @click="switchProfileTabs('data-set')" :class='(activeTab == "data-set")?"active":"inactive"' style="width:20% !important;font-size:18px;">{{$t('Data Set')}}</a>
                                </div>
                            </div>
                        </div>
                    </nav>
                   <div v-if="activeTab == 'tag-faces'" class="personalities-main-wrappers" :style="{'height':resizedHeight}" style=" display: inline-block; overflow: auto; width: 100%;padding:15px 0px">
                        <div class="primary-btn-style justify-content-end pt-2 col-md-4" style="float: inline-end; width: 30%; display: inline-block;position: absolute;top: 58px;inset-inline-end :10px;">
                            <button @click="getIndividualyPersonlityData();" title="Refresh" class="btn btn-outline-secondary mr-1 common-action-btn refresh-action" style="width:90px"> {{$t('Refresh')}} </button>
                            <button @click="addToDataSetRequest()" class="btn btn-outline-primary m-2" style="width:130px" >{{$t('Add to Data set')}}</button>
                        </div>
                        <div style="overflow:auto;height:100%" class="w-100">
                            <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                                <!-- <div style="margin: 5px 19px 0px 19px;" v-on:click="addUserFromBrowse()">
                                    <div class="add-user-icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                        </svg>
                                    </div>
                                    <div>Upload Image</div>
                                </div> -->
                                <div style="float: inline-start; display: flex;height: 93px;width: 160px;margin: 5px 10px 10px 10px;justify-content: center;align-items:center">
                                    <div v-if="(isEnabled('Upload') || getLoggedInUserInfo().user_type != 'Client')" class="nav-item dropdown show">
                                        <a class="nav-item nav-link dropdown-toggle icon-background-on-hover" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="padding:0px !important">
                                            <div>
                                                <div class="add-user-icon-wrapper">
                                                    <div style="height: 52%;display: inline-flex;width: 100%;align-items: flex-end;justify-content: center;">    
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                        </svg>
                                                    </div>    
                                                    <div>{{$t('Upload')}}</div>
                                                </div>
                                            </div>    
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions" style="box-shadow: #919191 0px 0px 3px 1px;background:#292929 !important;width:200px;inset-inline-start:-20px">
                                            <a v-if="((isEnabled('catalogs-workspace') || isEnabled('bins-workspace')) && getLoggedInUserInfo().user_type != 'Client')" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('fusion')">
                                                <div style="height:20px;width:20px">
                                                    <img :src="fusionLogo" style="width:100%;height:100%;position: relative;inset-inline-end :4px;">
                                                </div>
                                            <span>{{$t('from fusion')}}</span>
                                            </a>
                                            <a v-if="isEnabled('Upload')" class="dropdown-item p-2" style="position:relative;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="position: relative;inset-inline-end :4px;" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                                <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                            </svg>
                                            <span>{{$t('from your computer')}}</span>
                                            <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                                    <input 
                                                        style="height:100%;width:100%"
                                                        type="file"
                                                        id="file"
                                                        ref="uploadFile"
                                                        multiple
                                                         v-on:click="resetImageUploader()"
                                                        v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                                        accept="image/*, video/*"
                                                        />
                                                       
                                                </div></a>
                                        </div>
                                    </div>
                                </div>
                                <template v-for="file in personalityData.file_info">
                                    <div :key="file.file_uid" class="comm-tags-class">
                                        <div class='user-name-or-image' :title="file.file_name.split('.').slice(0, -1).join('.')" @click.prevent.stop="openfaceDetectionWidnow(file)">
                                            <img :src="getThumbnailPath(file)" @error="replaceByDefaultImage" :class="!(file.mime_type.startsWith('image')) ? 'disbled-files':''" style="max-width: 100%; max-height: 100%;object-fit: contain;">
                                            <div v-html="getSvgIconsOfMediaTypes(file)" class="svg-icons-display"></div>
                                            <div class="shortcut-actions-type-icons-wrapper"> <!-- :class="eOMenu?'overWriteShortcutIconWrapper':''"-->
                                                <!-- <svg @click="openfaceDetectionWidnow(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-emoji-smile-fill" viewBox="0 0 16 16">
                                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>
                                                </svg> -->
                                                <svg @click.prevent.stop="openfaceDetectionWidnow(file)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                                                    <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"/>
                                                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                                </svg>
                                                <svg @click.prevent.stop="removeProfileFromProfilesList(file.file_uid)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                                </svg>
                                            </div>  
                                            <div class="face-detect-status-wrapper">
                                              <!-- <template v-if="isFHD(file)"> -->
                                                <svg v-if="file.mime_type.startsWith('image') && (!file.objects_info || ('objects_info' in file && file.objects_info.length == 0))" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="orange" class="bi bi-clock-history" viewBox="0 0 16 16">
                                                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                                                    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                                                    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
                                                </svg>
                                                <svg v-if="checkIsFaceExistWithMultipleFaces(file)" :dataf-version-id="file.version_id" :dataf-ile-uid="file.file_uid" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#169116" class="bi bi-person-fill-check exisited-profile-face" viewBox="0 0 16 16">
                                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                                    <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                </svg>
                                                <svg v-if="checkFaceNotExistWithMultipleFaces(file)" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="orange" class="bi bi-person-fill-exclamation" viewBox="0 0 16 16">
                                                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"/>
                                                </svg>
                                                <svg v-if="checkExistedFaceIsInExpectedWidth(file)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#d75555" class="bi bi-person-fill-x" viewBox="0 0 16 16">
                                                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"/>
                                                </svg>
                                              <!-- </template> -->
                                                <!-- <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#d75555" class="bi bi-person-fill-x" viewBox="0 0 16 16">
                                                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"/>
                                                </svg> -->
                                            </div>  
                                        </div>
                                    </div> 
                                </template>
                            </div>   
                        </div>
                    </div>
                    <div v-if="activeTab == 'data-set'" style="overflow:auto;height:calc(100% - 90px);padding: 15px 0px" class="w-100">
                        <div class="primary-btn-style justify-content-end pt-2 col-md-4" style="float: inline-end; width: 30%; display: inline-block;position: absolute;top: 58px;inset-inline-end :10px;">
                            <button @click="getPersonalityDataSet();" title="Refresh" class="btn btn-outline-secondary mr-1 common-action-btn refresh-action" style="width:90px"> {{$t('Refresh')}} </button>
                            <button @click="trainDataSetRequest()" class="btn btn-outline-primary m-2" style="width:130px" >{{$t('Train Data set')}}</button>
                        </div>
                        <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                           <template v-for="personality in dataSetList">
                                <div  v-if="Object.keys(personality).includes('cropped_face_path') && personality.cropped_face_path" :title="personality.file_name.split('.').slice(0, -1).join('.')" :key="personality._id" class="comm-tags-class" style="width:100px;padding: 5px;margin-bottom: 8px;position:relative">
                                    <div class="data-set-personality-img">
                                        <div v-if="Object.keys(personality).includes('cropped_face_path') && personality.cropped_face_path" class='user-name-or-image-data-set'>
                                            <img :src="getProxyConvertedURL(personality.cropped_face_path)" @error="replaceWithUserIcon($event,personality.name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px;object-fit: contain;">
                                        </div>
                                        <div v-else class="user-name-or-image-data-set" :title="personality.name" :style="style(personality.name)" >{{personality.name.split("")[0]}}</div>
                                        <!-- <div style="text-align:center;word-break: break-all;" >{{personality.name}}</div> -->
                                        <div class="shortcut-actions-type-icons-wrapper" style="top:0px !important"> <!-- :class="eOMenu?'overWriteShortcutIconWrapper':''"-->  
                                                <svg @click="deleteProfileFromDataSet(personality.version_id)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                                </svg>
                                            </div>  
                                    </div>
                                    <!-- <div class="hover-action">
                                        <EditIcon class="edit-user-icon" @click.native="editProfile(personality)"></EditIcon>
                                        <CancelIcon class="delete-user-icon" @click.native="deleteProfile(personality._id, personality.name)"></CancelIcon>
                                    </div> -->
                                    </div>
                            </template>
                        </div>
                    </div>    
                    <attach-file 
                        ref="attachment-panel"
                        v-if="openAttachments" 
                        v-bind="attachmentData()" 
                        :alreadyAttachedFiles="attachedFiles" 
                        uniqueId='faceDetectionProfile' 
                        @openPipOfAttachment="openPipOfAttachment" 
                        @attachedFilesList="attachedFilesList" 
                        :enableDeleteIcon="true" 
                        :abortInProgressUpload="abortUpload" 
                        @abortedInProgressFiles="abortedInProgressFiles" 
                        :customUploadPath="uploadPathObj"
                        style="position: absolute; width: 99%; z-index: 1; bottom: 0px; max-height: 300px; overflow: auto; background: #141719; padding: 10px;box-shadow: 0px 0px 3px 1px #3c3c3c;inset-inline-start:0.5%;"
                    >
                    </attach-file>
                </div>
            </div>
        </div>
        <facedetection-window
        v-if="isfaceDetectionWidnowOpen"
        :filesInfo="faceDetectionFileInfo"
        :faceDetectContext="fromPersonalityContext"
        :parentActivePersonalityId="personalityId"
        @closeFaceModel="closeFaceModel()"
        ></facedetection-window>
        <custom-message v-if="enableCustomMessage" v-bind="currentProperties" @close="enableCustomMessage = false" @allowDeletion="userConfirmResp" @forceTrainDataset="trainDataSetRequest()"></custom-message>
        <learn-about :is="selectedComponenet" @close="closeLearnAboutPanel"></learn-about>
    </div>
</template>

<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import BackButton from "../core/backButton.vue";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js"
import fileBrowseModel from "../files/filesBrowse.vue";
import attachFiles from "../core/Attachments.vue"
import faceDetectionWidnow from "../faceDetection/faceDetection.vue"
import { NotifierConstants } from "../../components.constants";
import CustomMessage from "../actions/customAlertMessage.vue";
import LearnAbout from "./LearcnAboutProfiles.vue";
export default {
    props:["personalityId"],
    data() {
        return{
            personalityData:[],
            getUserConfirmForDelete:false,
            selectedTagFileUid:"",
            selectedDataSetVersionId:"",
            forceTrainOnFileRemove:false,
            fusionLogo:Utils.getLogo(),
            browserType:"",
            fileBrowseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
            attachedFiles:[],
            openFileBrowse:false,
            attachedFilesArr:[],
            openAttachments:false,
            selectedFilesFromAttachments:null,
            emptyfiles:false,
            customizeStyles:{
               "background": "#22272b",
               "border": "1px solid  #434343"
            },
            // resizedHeight: 'calc(100% - 70px)',
            resizedHeight: 'calc(100% - 115px)',
            abortUpload:false,
            personalityUploadPath:null,
            isfaceDetectionWidnowOpen:false,
            faceDetectionFileInfo:[],
            fromPersonalityContext:"fromPersonalityContext",
            activeTab:"tag-faces",
            dataSetList:[],
            dataSetVersionIds:[],
            uploadPathObj:{"catalogUploadPath":"", "uploadPath":""},
            uploadContext:null,
            enableCustomMessage:false,
            displayMessage:null, 
            messageTitle:null,
            selectedComponenet:null,
        };
    },
    watch:{
        displayMessage(newVal, oldVal){
            console.log("oldVal",typeof(oldVal))
            if(newVal && newVal.trim().length){
            this.enableCustomMessage = true
            }else{
            this.enableCustomMessage = false
            }
        }
    },
    components:{
    "back-button":BackButton,
    "files-browser":fileBrowseModel,
    "attach-file":attachFiles,
    "facedetection-window" : faceDetectionWidnow,
    "custom-message":CustomMessage,
    "learn-about":LearnAbout
    },

    computed:{
        getWorkspacesList(){
            return this.fileBrowseWorkspaceList;
        },
        
        checkIsDataSetImagesLength(){
            let count = 0;
            for(let i=0; i<this.dataSetList.length;i++){
                if('cropped_face_path' in this.dataSetList[i] && this.dataSetList[i].cropped_face_path){
                    count ++;
                }
            }
            return count;
        },

        currentProperties() {
        return {"messageTitle":this.messageTitle,
                "messageType": "",
                "displayMessage":this.displayMessage,
                "getUserConfirmation":this.getUserConfirmForDelete,
                "isDatasetTrainReq":this.forceTrainOnFileRemove
            }
        },
        ...mapGetters("users",["getLoggedInUserPrivilege"])  
    },
    methods:{

        isFHD(file) {
            let fileWidth = 0
            let fileHeight = 0
            if('width' in file){
                fileWidth = file.width
            }
            if('height' in file){
                fileHeight = file.height
            }

            return fileWidth >= 1920 || fileHeight >= 1080
        },
        getSvgIconsOfMediaTypes(path,type){
            return Utils.determineSvgIconForType(path,type)
        },

        openLearnAboutPanel(){
            this.selectedComponenet = 'learn-about';
            this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
            this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
        },

        closeLearnAboutPanel(){
            this.selectedComponenet = null;
            this.$refs.fadeWhenModelOpen.style.opacity = 1;
            this.$refs.fadeWhenModelOpen.style.pointerEvents = "auto";
        },

        handleResize(){
            if(this.$refs["attachment-panel"] && this.$refs["attachment-panel"].$el != undefined){
                let height = this.$refs["attachment-panel"].$el.getBoundingClientRect().height;
                height = `calc(100% - ${height}px)`;
                this.resizedHeight  = height;
            }else{
                this.resizedHeight  = 'calc(100% - 70px)';
            }  
        },

        changeComponent(comp){
            if(this.forceTrainOnFileRemove){
                this.getUserConfirmForDelete = false
                this.messageTitle = "Train Dataset"
                this.displayMessage = "Tagged Face is removed from Dataset. Please re-train the dataset."
                this.enableCustomMessage = true
            }else{
                this.$emit("changeSelectedComponent", comp);
            }
        },

        closeModal(){
            this.attachedFiles = [];
            this.browserType = '';
        },
        
        switchProfileTabs(tabType){
            this.activeTab = tabType;
            this.selectedDataSetVersionId = ""
            this.selectedTagFileUid = ""
            if(tabType == "data-set"){
                this.getPersonalityDataSet();
            }else if(tabType == "tag-faces"){
                this.getIndividualyPersonlityData();
            }
        },

        checkIsFaceExistWithMultipleFaces(fileInfo){
            if(fileInfo.mime_type.startsWith('image')){
                if('objects_info' in fileInfo && fileInfo.objects_info.length == 1){
                    let coordinateValues = fileInfo.objects_info[0].coordinates;
                        if(coordinateValues[2] - coordinateValues[0] > 64){
                            return true;
                        }else{
                            return false;
                        }
                }else if('objects_info' in fileInfo && fileInfo.objects_info.length>1){
                    let faceIndex = fileInfo.objects_info.findIndex((obj)=> obj.object_id == this.personalityData._id);
                    if(faceIndex >=0){
                        let coordinateValues = fileInfo.objects_info[faceIndex].coordinates;
                    
                        if((coordinateValues[2] - coordinateValues[0] >= 64) && (coordinateValues[3] - coordinateValues[1] >= 64)){
                            return true;
                        }else{
                            return false;
                        }    
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }else{
                return false;
            }    
        },

        checkExistedFaceIsInExpectedWidth(fileInfo){
            if(fileInfo.mime_type.startsWith('image') == false){
                return true;
            }else if('objects_info' in fileInfo && fileInfo.objects_info.length >0){
                let faceIndex = fileInfo.objects_info.findIndex((obj)=> obj.object_id == this.personalityData._id);
                if(faceIndex >=0){
                    let coordinateValues = fileInfo.objects_info[faceIndex].coordinates;
                    if((coordinateValues[2] - coordinateValues[0] < 64) || (coordinateValues[3] - coordinateValues[1] < 64)){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }    
            }else{
                return false;
            }
        },

        checkFaceNotExistWithMultipleFaces(fileInfo){
            if(fileInfo.mime_type.startsWith('image')){
                if(fileInfo && 'objects_info' in fileInfo && fileInfo.objects_info.length > 1){
                    let faceIndex = fileInfo.objects_info.findIndex((obj)=> obj.object_id == this.personalityData._id);
                    if(faceIndex == -1){
                        return true;
                    }else if(faceIndex >=0 && fileInfo.objects_info[faceIndex].user_trained == false){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }else{
                return false;
            }    
        },

        attachmentData(){
            return {selectedFilesFromAttachBrowse:this.selectedFilesFromAttachments}
        },

        getSelectedFileDetailsFromBrowse(){
            this.selectedFilesFromAttachments = this.$refs.uploadFile.files;
            this.browserType = "";
            this.openAttachments = true;    
        },

        attachedFilesList(attcahedFilesArray,alreadyAttachedFiles){
            this.attachedFilesArr = [];
            if(alreadyAttachedFiles != undefined && alreadyAttachedFiles.length){
                for(let j = 0; j< alreadyAttachedFiles.length; j++){
                    this.attachedFilesArr.push(alreadyAttachedFiles[j].file_uid);
                }
            }
            if(attcahedFilesArray != undefined && attcahedFilesArray.length){
                for(let i=0; i<attcahedFilesArray.length; i++){
                    this.attachedFilesArr.push(attcahedFilesArray[i].fileUID);
                }
            }
            this.updatePersonalityFileUid(this.attachedFilesArr, 'add', 'fileUids');
        },
        userConfirmResp(){
            if(this.activeTab == 'data-set'){
                this.allowToRemoveSelectedDataSetFile()
            }else{
                this.allowToRemoveSelectedTagFile()
            }
            this.enableCustomMessage = false
        },
        removeProfileFromProfilesList(fileUid){
            this.getUserConfirmForDelete = true;
            this.messageTitle = "Delete"
            this.displayMessage = "Are you sure you want to delete ?"
            this.selectedTagFileUid = fileUid
            this.enableCustomMessage = true
        },
        allowToRemoveSelectedTagFile(){
            if (this.selectedTagFileUid) {
                let payload = {};
                payload["personalityId"] = this.personalityData._id;
                payload["fileUid"] = this.selectedTagFileUid;
                this.removePersonalityFromTagfaces(payload).then((data)=>{
                    console.log("data", data);
                });
                this.selectedTagFileUid = ""
                this.enableCustomMessage = false
            }   
        },

        resetImageUploader(){
           this.$refs.uploadFile.value = '';
        },

        openPipOfAttachment(fileInfo){
            this.$emit("openPipOfSelectedFile",fileInfo)
        },
        abortedInProgressFiles(){
            this.$emit("close");
        },

        handleFilesBrowse(selectedFiles){
            this.attachedFiles = selectedFiles;
            this.openAttachments = true;
            this.browserType = '';
        },

        openfaceDetectionWidnow(fileInfo){
            this.faceDetectionFileInfo = [];
            if(fileInfo){
                this.faceDetectionFileInfo.push(fileInfo);
            }
            this.isfaceDetectionWidnowOpen = true;
        },  
        closeFaceModel(){
            this.isfaceDetectionWidnowOpen = false;
        },

        getThumbnailPath(file){
            return Utils.getThumbnailPathfromFileInfo(file)
        },

        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        updatePersonalityFileUid(fileInfo, actionType, fileType){
            let payload = {};
            payload["personalityId"] = this.personalityData._id;
            let params = {};
            let fileUidsList = [];
            if(actionType == 'add'){
                if(fileType == "fileinfo" && fileInfo && Array.isArray(fileInfo)){
                    for(var i=0;i<fileInfo.length;i++){
                        if('file_uid' in fileInfo[i] && !fileUidsList.includes(fileInfo[i].file_uid)){
                            fileUidsList.push(fileInfo[i].file_uid);
                        }
                    }
                }else if(fileType == "fileUids"){
                    fileUidsList = this.attachedFilesArr;
                }

                this.$nextTick(()=>{
                    if(fileUidsList.length>0){
                        params["added_uids"] = fileUidsList;
                    }
                });    
            }else if(actionType == "delete"){
                if(fileInfo){
                    params["removed_uids"] = [fileInfo];
                }
            }
            this.$nextTick(()=>{
                payload.params = params;

                this.updateIndPersonalityFromServe(payload).then((data)=>{
                    console.log(data)
                    if(actionType == "delete"){
                        this.$toast.info("Delete request Submitted")
                    }else if(actionType == "add"){
                        this.$toast.info("Add New profile image request Submitted");
                    } 
                });
            });    
        },

        createFaceDetectionJob(fileUid){
            let payload = {
                file_uid: fileUid,
                crop:[],
                job_name: "Face Detection",
                element_type: "file"
            }
            this.createNewJob(payload).then((data)=>{
                console.log(data)
            });
        },

        isEnabled(prev){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, prev)
        },

        openFileBrowseOnClick(browser){
            this.browserType = "fusion";
            this.uploadContext = "fusion";
            if(browser == 'fusion'){
                this.fileBrowseWorkspaceList = [Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS];
            }
        },

        addToDataSetRequest(){
            let payload = {};
            let supportedFileUid = [];
            [].map.call(this.$el.querySelectorAll('.exisited-profile-face'),(el)=>{
                if(!supportedFileUid.includes(el.getAttribute("dataf-ile-uid"))){
                    supportedFileUid.push(el.getAttribute("dataf-ile-uid"));
                }    

            });
            let supportedVersionIds = [];
            [].map.call(this.$el.querySelectorAll('.exisited-profile-face'),(el)=>{
                if(!supportedVersionIds.includes(el.getAttribute("dataf-version-id"))){
                    supportedVersionIds.push(el.getAttribute("dataf-version-id"));
                }    

            });
            if(supportedVersionIds.length==0){
                this.displayMessage = "Please Upload valid images to Add to data set";
                this.messageTitle = "Add to Data Set";
                return false;
            }
            payload["file_uids"] = supportedFileUid;
            payload['version_ids'] = supportedVersionIds;
            payload["personality_id"] = this.personalityData._id;
            payload["job_name"]= "Add To Data Set";
            payload["element_type"]= "file";
            this.createNewJob(payload).then((data)=>{
                if(Utils.isAcceptedStatusCode(data.statusCode)){
                    this.$toast.success("Add to Data Set job submitted successfully.");
                }else{
                    this.$toast.error(data.message);
                }
            });

        },

        trainDataSetRequest(){
            if(!this.forceTrainOnFileRemove && this.checkIsDataSetImagesLength < 20){
                this.displayMessage = "Please add minimum 20 valid images to train data set";
                this.messageTitle = "Train Data Set";
                this.enableCustomMessage = true;
                return false;
            }
            this.forceTrainOnFileRemove = false
            this.selectedDataSetVersionId = ""
            this.enableCustomMessage = false
            let payload = {};
            payload["personality_id"] = this.personalityData._id;
            payload["job_name"]= "Train Data Set";
            payload["element_type"]= "file";
            payload["resource_name"] = this.personalityData.name;
            payload['version_ids'] = this.dataSetVersionIds;
             this.createNewJob(payload).then((data)=>{
                if(Utils.isAcceptedStatusCode(data.statusCode)){
                    this.$toast.success("Train Profile job submitted successfully.");
                }else{
                    this.$toast.error(data.message);
                }
            });

        },

        deleteProfileFromDataSet(version_id){
            this.getUserConfirmForDelete = true
            this.messageTitle = "Delete"
            this.displayMessage = "Are you sure you want to delete ?"
            this.selectedDataSetVersionId = version_id;
            this.enableCustomMessage = true
        },
        allowToRemoveSelectedDataSetFile(){
            if(this.selectedDataSetVersionId) {
                let payload = {};
                payload["personalityId"] = this.personalityData._id;
                payload["version_id"] = this.selectedDataSetVersionId;
                let params = {};
                payload.params = params;
                this.deleteFileFromDataSetFromServer(payload).then((data)=>{
                    console.log(data);
                })
                this.selectedDataSetVersionId = ""
                this.enableCustomMessage = false
                this.forceTrainOnFileRemove= true
            } 
        },

        findremovedValue(oldArray, newArray) {
            const removedindex = oldArray.findIndex(item => !newArray.includes(item));
            if (removedindex !== -1) {
                return oldArray[removedindex];
            }
            return undefined; // Return undefined if no new value is found
        },

        getIndividualyPersonlityData(){
            let payload = {};
            payload["personalityId"] = this.personalityId;
            this.getIndividualPersoanlityDataFromServer(payload).then((data)=>{
                this.personalityData = data.personality;
                this.personalityUploadPath = this.personalityData.database_path;
            });
        },        

        getPersonalityDataSet(){
            let payload = {};
            payload["personalityId"] = this.personalityData._id;
            let params = {};
            payload.params = params;
            this.getDataSetDataFromServer(payload).then((data)=>{
                this.dataSetList = data.file_info;
                this.dataSetVersionIds = data.data_set_version_ids;
            });
        },

        getFaceDetectionConfigData(){
            let payload = {};
            this.getFaceDetectionConfigDataFromServer(payload).then((data)=>{
                this.uploadPathObj["catalogUploadPath"] = data.vision.upload_category;
                this.uploadPathObj["uploadPath"] = data.vision.upload_path;
            });
        },

        handleRemoveDatasetProfileNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let profile_info = notification.message;
                if([NotifierConstants.removeFromPersonalityNotification].includes(notification.message_type)){
                    if(this.personalityData._id == profile_info.personality_id){
                        let fileIndex = this.personalityData.file_uids.findIndex((uid)=>uid == profile_info.file_uid);
                        if(fileIndex >=0){
                            this.personalityData.file_uids.splice(fileIndex, 1);
                        }
                        this.personalityData.file_info = this.personalityData.file_info.filter((obj)=>obj.file_uid != profile_info.file_uid);
                    }    
                }
            }        
        },

        handleProfileUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let profile_info = notification.message;
                if([NotifierConstants.personalityUpdateNotification].includes(notification.message_type)){
                    if(this.personalityData._id == profile_info._id){
                        if('new_file_uids' in profile_info){
                            this.personalityData.file_uids = this.personalityData.file_uids.concat(profile_info['new_file_uids'])
                            if('new_file_version_id' in profile_info){
                                this.personalityData.version_ids = this.personalityData.version_ids.concat(profile_info['new_file_version_id'])
                            }
                            let new_file_info = profile_info['new_file_info'].filter(ob=>'file_uid' in ob)
                            this.personalityData.file_info = this.personalityData.file_info.concat(new_file_info)
                            return
                        }
                        if(this.uploadContext == "fusion"){
                            let payload = {};
                            payload["personalityId"] = this.personalityData._id;
                            this.getIndividualPersoanlityDataFromServer(payload).then((data)=>{
                                this.personalityData = data.personality;
                            });
                        }

                        this.personalityData.file_uids = profile_info.file_uids;
                        if('version_ids' in profile_info){
                            this.personalityData.version_ids = profile_info.version_ids;
                        }

                        this.emptyfiles = true;
                        this.openAttachments = false;
                        this.attachedFilesArr = [];
                        this.attachedFiles = [];
                        this.browserType= '';
                        this.selectedFilesFromAttachments = '';
                        this.uploadContext = null;
                    }

                   
                }
                // else if([NotifierConstants.personalityDeleteNotification].includes(notification.message_type)){
                //     if(this.personalityData._id == profile_info._id){    
                //         let removedprofileUid = this.findremovedValue(this.personalityData.file_uids, profile_info.file_uids);
                //         this.$nextTick(()=>{
                //             if(removedprofileUid){
                //                 this.personalityData.file_uids = this.personalityData.file_uids.filter((uid) => uid != removedprofileUid); 
                //             }
                //         });    
                //     }
                // }    
            }    
        },

        handleAssetCreatedNotification(){
            // notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            // if(notification.message){
            //     let fileUid = notification.message.file_uid;
            //     if(this.personalityData.file_uids.includes(fileUid)){

            //     }    
            // }
        },

        handleCustomProxyNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let message = notification.message
                if(message.proxy_info && 'file_uid' in message &&
                   'hires_thumbnail' in message.proxy_info && message.proxy_info.hires_thumbnail){
                    let fileUid = message.file_uid
                    let fileIndex = this.personalityData.file_uids.findIndex((uid) => uid == fileUid);
                    if(fileIndex>=0 &&'file_info' in this.personalityData && this.personalityData['file_info']){
                        let filteredFileInfoObj = this.personalityData.file_info.find(obj=>obj.file_uid == fileUid);
                        if(filteredFileInfoObj){
                            this.$set(filteredFileInfoObj["proxy_info"], 'hires_thumbnail', Utils.convertToLoginIPDomainName(message.proxy_info.hires_thumbnail));
                            if(filteredFileInfoObj && filteredFileInfoObj.mime_type && filteredFileInfoObj.mime_type.startsWith("image/")){
                                this.createFaceDetectionJob(fileUid);
                            }else{
                                console.log("createFaceDetectionJob : Personalities : unsupported format for auto face detection job submission : ",filteredFileInfoObj.mime_type)
                            }
                        }
                    }
                }
            }
        },
        handleAssetThumbnailUpdatedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let fileUid = notification.message.file_uid;
                let assetNotificationInfo = notification.message;
               
                if(this.personalityData.file_uids && this.personalityData.file_uids.includes(fileUid)){
                    let fileIndex = this.personalityData.file_uids.findIndex((uid) => uid == fileUid);
                    if(fileIndex>=0){
                        if('file_info' in this.personalityData && this.personalityData['file_info']){
                            let fileIndexInFielInfo = this.personalityData.file_info.findIndex((obj)=>obj.file_uid == fileUid);
                            let filteredFileInfoObj = this.personalityData.file_info[fileIndexInFielInfo];
                            if(fileIndexInFielInfo>=0){
                                let reloadThumbnail = false;
                                if(!('proxy_info' in filteredFileInfoObj) || Object.keys(filteredFileInfoObj.proxy_info) <= 0 ){
                                    reloadThumbnail = true;
                                }else if('proxy_info' in filteredFileInfoObj &&
                                            (filteredFileInfoObj.proxy_info.thumbnail_uri !=  assetNotificationInfo.proxy_info.thumbnail_uri ||
                                            filteredFileInfoObj.proxy_info.lowres_uri !=  assetNotificationInfo.proxy_info.lowres_uri)){
                                    reloadThumbnail = true;
                                }
 
                                if(reloadThumbnail){
                                    if('proxy_info' in filteredFileInfoObj && Object.keys(filteredFileInfoObj.proxy_info)){
                                        this.$set(filteredFileInfoObj.proxy_info ,"thumbnail_uri", Utils.convertToLoginIPDomainName(assetNotificationInfo.proxy_info.thumbnail_uri));
                                        this.$set(filteredFileInfoObj.proxy_info ,"lowres_uri", assetNotificationInfo.proxy_info.lowres_uri);
                                    }else{
                                        this.$set(filteredFileInfoObj, "proxy_info", assetNotificationInfo.proxy_info);
                                    }
                                    // Comment this as we are now depending the job POST of CUSTOM_PROXY_GENERATED Notification
                                    // if(filteredFileInfoObj && filteredFileInfoObj.mime_type && filteredFileInfoObj.mime_type.startsWith("image/")){
                                    //     this.createFaceDetectionJob(fileUid);
                                    // }else{
                                    //     console.log("createFaceDetectionJob : Personalities : unsupported format for auto face detection job submission : ",filteredFileInfoObj.mime_type)
                                    // }
                                }   
                            }else{
                                let fileInfo = {};
                                fileInfo["_id"] = assetNotificationInfo._id;
                                fileInfo["duration"] = assetNotificationInfo.duration;
                                fileInfo["file_name"] = assetNotificationInfo.file_name;
                                fileInfo["file_uid"] = assetNotificationInfo.file_uid;
                                if('height' in assetNotificationInfo){    
                                    fileInfo["height"] = assetNotificationInfo.height;
                                }   
                                fileInfo["mime_type"] = assetNotificationInfo.mime_type;
                                fileInfo["path"] = assetNotificationInfo.path;
                                fileInfo["proxy_info"] = assetNotificationInfo.proxy_info;
                                fileInfo["storage_class"] = assetNotificationInfo.storage_class;
                                if('width' in assetNotificationInfo){    
                                    fileInfo["width"] = assetNotificationInfo.width;
                                }  
                                this.personalityData.file_info.push(fileInfo);
                                // this.createFaceDetectionJob(fileUid);
                            }
                        }else{
                            // let fileIndexInFielInfo = this.personalityData.file_info.findIndex((obj)=>obj.file_name == fileUid);
                            let fileInfo = {};
                            fileInfo["_id"] = assetNotificationInfo._id;
                            fileInfo["duration"] = assetNotificationInfo.duration;
                            fileInfo["file_name"] = assetNotificationInfo.file_name;
                            fileInfo["file_uid"] = assetNotificationInfo.file_uid;
                            if('height' in assetNotificationInfo){    
                                fileInfo["height"] = assetNotificationInfo.height;
                            }   
                            fileInfo["mime_type"] = assetNotificationInfo.mime_type;
                            fileInfo["path"] = assetNotificationInfo.path;
                            fileInfo["proxy_info"] = assetNotificationInfo.proxy_info;
                            fileInfo["storage_class"] = assetNotificationInfo.storage_class;
                            if('width' in assetNotificationInfo){    
                                fileInfo["width"] = assetNotificationInfo.width;
                            } 
                            let fileInfoList =  [];
                            fileInfoList.push(fileInfo);
                            this.$set(this.personalityData, "file_info", fileInfoList);
                            // this.createFaceDetectionJob(fileUid);
                        }   
                    }
                }
            }    
        },
        handleFileUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message && 'file_info' in this.personalityData && this.personalityData.file_info){
                let fileInfo = notification.message
                let fIndx = this.personalityData.file_info.findIndex((obj)=>obj.file_uid == fileInfo.file_uid);
                if(fIndx >= 0){
                    this.$set(this.personalityData.file_info[fIndx], "version_id", fileInfo.version_id)
                    if(this.personalityData.version_ids && this.personalityData.version_ids.length > 0 && !this.personalityData.version_ids.includes(fileInfo.version_id)){
                        this.personalityData.version_ids.push(fileInfo.version_id)
                    }else{
                        this.personalityData['version_ids'] = [fileInfo.version_id]
                    }
                }
            }
        },

        handleFDUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let fd_info = notification.message
                if([NotifierConstants.faceDetectionCreateNotification, NotifierConstants.faceDetectionUpdateNotification].includes(notification.message_type)){
                    if(this.personalityData.version_ids && this.personalityData.version_ids.includes(fd_info.version_id)){
                        let fileIndex = this.personalityData.file_info.findIndex((file) => file.version_id == fd_info.version_id);
                        if(fileIndex >= 0){
                            let fileInfo = this.personalityData.file_info[fileIndex];
                            if(fd_info.version_id == fileInfo.version_id){
                                this.$set(fileInfo, "objects_info", fd_info.objects_info);
                            }
                        }    
                    } 
                }       
            }
        },

        handleDataSetUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let dataSetInfo = notification.message;
                if([NotifierConstants.addedToPersonalityDataSetNotification].includes(notification.message_type)){
                    let versionId = dataSetInfo.version_id;
                    if(this.personalityData._id == dataSetInfo.personality_id && this.personalityData.version_ids.includes(versionId)){
                        this.personalityData.file_info = this.personalityData.file_info.filter((obj)=>obj.version_id != versionId);
                    }
                }
            }   
        },

        handleDataSetCompletedUpdateNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let dataSetCompletedInfo = notification.message;
                if([NotifierConstants.addedToPersonalitiesDataSetCompletedNotification].includes(notification.message_type)){
                    if(this.personalityData._id == dataSetCompletedInfo.personality_id){
                        this.$toast.info("Add to Personality data set is completed");
                    }
                }
            }        
        },

        handleRemoveDataSetNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let dataSetInfo = notification.message;
                if([NotifierConstants.removeFromDataSetNotification].includes(notification.message_type)){
                    if(this.personalityData._id == dataSetInfo.personality_id){
                        let fileIndex = this.dataSetList.findIndex((obj)=>obj.version_id == dataSetInfo.version_id);
                        if(fileIndex>=0){
                            this.dataSetList = this.dataSetList.filter((obj)=>obj.version_id != dataSetInfo.version_id);
                        }
                        this.dataSetVersionIds = this.dataSetVersionIds.filter(vid=>vid != dataSetInfo.version_id)
                    }
                }
            }        
        },
        
        handleTrainDataSetCompletedNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                let trainDataSetInfo = notification.message;
                if([NotifierConstants.trainDataSetCompletedNotification].includes(notification.message_type)){
                    if(this.personalityData._id == trainDataSetInfo.personality_id){
                        this.$toast.info("Train Data set of " +this.personalityData.name+ " is completed");
                    }
                }
            }            
        },

        registerforWebsocketNotifications(){
            this.addWSEventListener({eventname:[NotifierConstants.personalityUpdateNotification,NotifierConstants.personalityDeleteNotification],callback:this.handleProfileUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.removeFromPersonalityNotification],callback:this.handleRemoveDatasetProfileNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotification,parent:"CatalogsDisplay"})
            this.addWSEventListener({eventname:NotifierConstants.assetModifiedNotification , callback:this.handleAssetThumbnailUpdatedNotification,parent:"faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.faceDetectionCreateNotification,NotifierConstants.faceDetectionUpdateNotification],callback:this.handleFDUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.addedToPersonalityDataSetNotification],callback:this.handleDataSetUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.addedToPersonalitiesDataSetCompletedNotification],callback:this.handleDataSetCompletedUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.removeFromDataSetNotification],callback:this.handleRemoveDataSetNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.trainDataSetCompletedNotification],callback:this.handleTrainDataSetCompletedNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.fileModifiedNotification],callback:this.handleFileUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.customProxyGeneratedNotification],callback:this.handleCustomProxyNotification,parent: "faceDetectionPersonalitiesInd"});
        },

        UnregisterfromWebsocketNotifications(){
            this.removeWSEventListener({eventname:[NotifierConstants.customProxyGeneratedNotification],callback:this.handleCustomProxyNotification,parent: "faceDetectionPersonalitiesInd"});
            this.removeWSEventListener({ eventname:[NotifierConstants.personalityUpdateNotification, NotifierConstants.personalityDeleteNotification],callback:this.handleProfileUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.removeFromPersonalityNotification],callback:this.handleRemoveDatasetProfileNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotification,parent:"CatalogsDisplay"})
            this.removeWSEventListener({eventname:NotifierConstants.assetModifiedNotification , callback:this.handleAssetThumbnailUpdatedNotification,parent:"faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.faceDetectionCreateNotification,NotifierConstants.faceDetectionUpdateNotification],callback:this.handleFDUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.addedToPersonalityDataSetNotification],callback:this.handleFDUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.addedToPersonalitiesDataSetCompletedNotification],callback:this.handleDataSetCompletedUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.removeFromDataSetNotification],callback:this.handleRemoveDataSetNotification,parent: "faceDetectionPersonalitiesInd"})
            this.removeWSEventListener({eventname:[NotifierConstants.trainDataSetCompletedNotification],callback:this.handleTrainDataSetCompletedNotification,parent: "faceDetectionPersonalitiesInd"})
            this.addWSEventListener({eventname:[NotifierConstants.fileModifiedNotification],callback:this.handleFileUpdateNotification,parent: "faceDetectionPersonalitiesInd"})
        },

        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserInfo"]),
        ...mapActions("AIDataSet", ["updateIndPersonalityFromServe", "getIndividualPersoanlityDataFromServer", "getDataSetDataFromServer", "getFaceDetectionConfigDataFromServer", "deleteFileFromDataSetFromServer", "removePersonalityFromTagfaces"]),
        ...mapActions("jobs",["createNewJob"]),
            
    },
    // mounted(){
    //     this.$nextTick(() => {
    //         console.log("RRRRRRRRRRRRRRRRRRR",this.$refs["attachment-panel"].$el)
    //         if(this.$refs["attachment-panel"].$el){
    //             this.resizeObservor = new ResizeObserver(() =>{
    //                 // this.resizeObservor.disconnect();
    //                 this.handleResize();
    //             });
    //         }
    //     });    
    // },

    created(){
        this.getIndividualyPersonlityData();
        this.registerforWebsocketNotifications();
        this.getFaceDetectionConfigData();
    },

    beforeDestroy(){
        this.UnregisterfromWebsocketNotifications()
    }
}    
</script>

<style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $input-field-bg-color: #121212;
    $input-field-border-color: #202020;
    $input-field-height:38px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;

    .nav-item{
        color: $dull-text-color !important;
        display: inline-block;
        float: inline-start;
    }
    .inactive:hover{
    color:$text-color !important;
    }
    .active{
        background: $primary-background !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
        font-weight: 500;
        font-size:15px;
    }
    .top-nav-bar{
        background: $primary-background;
    }

    .comm-settings-top-nav{
        li{
            display: inline-flex;
            align-items: center;
        }
    }

    .breadcrumb{
        background-color: transparent !important;
    }

    .height-set{
        // height: calc(100vh - 52px);    
        height: 100%;
        width:100%;
        display: inline-block;
        background: #1a1e21 !important;
        .group-name{
        text-align: start;
        padding:16px 3%;
        font-size:27px;
        display:flex;
        }
        .group-members{
        height: calc(100% - 90px);
        cursor: pointer;
        }
    }

    .add-user-icon-wrapper{
        height: 89px;
        width: 160px;
        // line-height: 54px;
        border-radius: 6px;
        background: $primary-background;
        color: $add-button-text-color;
        border: 1px solid $add-button-border-color; 
        display:inline-block;

        div svg{
            width:24px;
            height:24px;
        }
    }

    .add-user-icon-wrapper:hover{
        color: $add-button-text-color-hover;
        border: 1px solid $add-button-border-on-hover; 
    }

    .editIcon {
        margin-inline-start: 9px;
        margin-top: 0px
    }

    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }

    .user-name-or-image{
        border: 1px solid #4a4a4a;
        border-radius: 10px;
        text-align: center;
        line-height: 56px;
        text-transform: uppercase;
        margin: 0 auto;
        font-size: 30px;
        height: 93px;
        width: 160px;
        position: relative;
        align-items: center;
        display: inline-flex;
        justify-content: center;
        top:0px !important;
    }

  .delete-user-icon{
    visibility: hidden;
  }

  .comm-tags-class:hover .delete-user-icon{
    visibility: visible;
  }

  .comm-tags-class{
        display: inline-flex;
        align-items: center;
        // width:100px;
        margin-bottom: 8px;
        position:relative;
        margin: 5px 10px 10px 10px;
        padding: 0px !important;
        justify-content: center;
  }

  .delete-user-icon{
    position: absolute;
    inset-inline-end: 11px;
    top: 1px;
    height: 23px;
    width: 23px;
    border: $border-color;
    background: $secondary-background-color;
    border-radius: 30px;
    color: $text-color;
  }

    .shortcut-actions-type-icons-wrapper{
        visibility: hidden;
        color: #999;
        background: #000000c9;
        min-width: 30px;
        width: auto;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        top: 3px;
        inset-inline-end: 3px;
        line-height: 1;
        margin-inline-start: 8px;
        border: unset;
        --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
        box-shadow: 0 0 0 1px var(--saf-0), 0 1px 3px 0 rgba(0, 0, 0, 0.08);
        display: flex;
        padding: 2px;
        border-radius: 0.375em;
        height: 30px;
        align-items: center;
        justify-content: center;
        svg{
            margin-inline-start: 6px;
            margin-inline-end: 6px;
        }
    }
    .user-name-or-image:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;
           
        }
    }

    .data-set-personality-img:hover{
        .shortcut-actions-type-icons-wrapper{
            visibility: visible;  
        }   
    }

    .face-detect-status-wrapper{
        position: absolute;
        bottom: 0px;
        inset-inline-end: 0px;
        padding: 5px;
        // height: 30px;
        display: inline-flex;
        // width: 30px;
        justify-content: center;
        align-items: center;
        background: #1a1a1ab3;
        border-radius: 4px 0px 0px 0px;
    }

    .user-name-or-image-data-set{
        height: 80px;
        width: 80px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 56px;
        text-transform: uppercase;
        margin: 0 auto;
        font-size: 30px;
    }

    .learn-about-text-styles{
        width: 200px !important;
        color:$learn-about-text-color;
        text-align: end;
        padding-inline-end: 17px;
        margin-top:10px;
        svg{
            margin-inline-end: 2px;
            margin-bottom: 3px;
        }
    }

    .learn-about-text-styles:hover{
        text-decoration: underline;
        color:$learn-about-text-color-hover;
    }

    .disbled-files{
        opacity: 0.4;
    }

    .svg-icons-display{
        position: absolute;
        display: inline-flex;
        width: 25px;
        height: 25px;
        background: #1a1a1ab3;
        align-items: center;
        justify-content: center;
        bottom: 0px;
        inset-inline-start:0px;
        padding:5px;
    }

     /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

</style>



